import { ChallengePayload } from '_api/types';

const DefaultNewChallenge: ChallengePayload = {
  title: '',
  description: '',
  equipment: [],
  instructionList: [],
  imageUrl: '',
  videoLink: '',
  shareWithOrg: false,
};

export default DefaultNewChallenge;
